<template>
  <div class="subscription-filter flex flex-wrap gap-3 items-end mb-2 pb-4">
    <div class="w-full sm:w-auto flex-grow" style="min-width: 200px;">
      <select-suggestion
        column="name,email"
        model="User"
        v-model="selectedUser"
        :label="$t('subscription.user')"
        :appendClearOption="true"
        :itemTextFormat="formatUserNameEmailHtml"
        dropdown-options-class="user-suggest-dropdown"
        placeholderText="Digite o nome ou e-mail do usuário"
        @input="emitFilters"
      />
    </div>

    <div class="w-full sm:w-auto flex-grow" style="min-width: 180px;">
      <label class="text-sm font-medium mb-1 block">{{ $t('subscription.status') }}</label>
      <v-select
        v-model="selectedStatus"
        :options="statusOptions"
        :reduce="opt => opt.value"
        label="label"
        :placeholder="$t('subscription.status') + ' - Todos'"
        @input="emitFilters"
        class="w-full"
      >
        <div slot="no-options">{{ $t('subscription.no_statuses') }}</div>
      </v-select>
    </div>

    <div class="flex items-end shrink-0 ml-3">
      <b-button variant="outline-danger" size="sm" @click="clearFilters">
        {{ $t('action.clear') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import SelectSuggestion from '@/components/SelectSuggestion.vue'
import { formatUserNameEmailHtml } from '@/util/suggestionLabelFormat'
import SubscriptionService from '@/services/api/SubscriptionService'

export default {
  name: 'SubscriptionFilter',
  components: {
    BButton,
    vSelect,
    SelectSuggestion
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        user_id: null,
        status: null
      })
    }
  },
  data() {
    return {
      selectedUser: null,
      selectedStatus: null,
      statusOptions: []
    }
  },
  methods: {
    formatUserNameEmailHtml,
    emitFilters() {
      const filters = {
        user_id: this.selectedUser?.id || null,
        status: this.selectedStatus || null
      }
      this.$emit('input', filters)
      this.$emit('change', filters)
    },
    clearFilters() {
      this.selectedUser = null
      this.selectedStatus = null
      this.emitFilters()
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.selectedStatus = newVal.status || null
        }
      },
      deep: true
    }
  },
  beforeMount() {
    SubscriptionService.build(this.$vs).findAllStatuses().then((data) => {
      this.statusOptions = data || []
    }).catch(() => {
      this.statusOptions = []
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.emitFilters()
    })
  }
}
</script>

<style scoped>
.subscription-filter {
  width: 100%;
}
</style>
